import { API, Auth } from "aws-amplify";
import { takeEvery, call, put, all } from "redux-saga/effects";
import * as photoShotTypes from "../../constants/PhotoShotsActionsTypes";
import * as shootService from "../../../services/shootService";
import _ from "lodash";

function* getPhotoShots(action) {
  try {
    let { clinic, date } = action;
    let { data } = yield call(
      shootService.getShootShots,
      { clinic, created_at: date },
      {
        params: {
          shot_type: "photo",
          withProgress: true
        }
      }
    );
    let length = data.shots.length;
    data.shots = data.shots.sort((a, b) => {
      let nameA = a.scene.toUpperCase();
      let nameB = b.scene.toUpperCase();
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
      return 0;
    });
    data.shots = _.reduce(
      data.shots,
      (accumulator, shot) => {
        if (accumulator[shot.scene]) {
          accumulator[shot.scene].data = accumulator[shot.scene].data.concat(shot);
          return accumulator;
        } else {
          accumulator[shot.scene] = {};
          accumulator[shot.scene].data = [];
          accumulator[shot.scene].name = shot.scene;
          accumulator[shot.scene].data = accumulator[shot.scene].data.concat(shot);
          return accumulator;
        }
      },
      {}
    );
    yield put({
      type: photoShotTypes.PHOTO_SHOT_FETCHED,
      data,
      length
    });
  } catch (err) {
    console.log(err);
  }
}

function* watchGetPhotoShots() {
  yield takeEvery(photoShotTypes.PHOTO_SHOT_FETCHING, getPhotoShots);
}

export default {
  watchGetPhotoShots
};
